import { CheckoutErrorsEnum } from '@src/domains/payments';

const ANTI_FRAUD_ERROR_CODE = 'AntiFraud';
const TRANSACTION_ERROR_CODE = 'Transaction';

export const classifyTransactionError = (
  status: number | undefined,
  errorType: string | undefined,
): CheckoutErrorsEnum => {
  switch (status) {
    case 400:
      switch (errorType) {
        case ANTI_FRAUD_ERROR_CODE:
          return CheckoutErrorsEnum.ANTIFRAUD;
        case TRANSACTION_ERROR_CODE:
          return CheckoutErrorsEnum.TRANSACTION;
        default:
          return CheckoutErrorsEnum.GENERIC;
      }
    case 401:
    case 403:
      return CheckoutErrorsEnum.UNAUTHORIZED;
    default:
      return CheckoutErrorsEnum.GENERIC;
  }
};
